<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormSelect2
    name="invoice"
    v-model="editor.invoice"
    bind-object
    :placeholder="messages.searchPlaceholder"
    :dataSource="b_2248226175642056_dataSource"
    valueField="id"
    textField="invoice_number"
    clearable
    optionTemplate="<UcSuggestInvoiceOption :option=option></UcSuggestInvoiceOption>"
    selectedOptionTemplate="<UcSuggestInvoiceOption v-if=&quot;option.id&quot; :option=option></UcSuggestInvoiceOption>"
    :readonly="editor.isReadonly"
    @optionSelected="evh_2248226175642056_optionSelected($event, {})"
  >
  </ItpFormSelect2>
  <ItpBox
    direction="column"
    v-if="loaded"
  >
    <ItpBox
      v-if="editor.invoice && !editor.invoice.id && editor.$_resource.invoice && editor.$_resource.invoice.invoice_number"
    >
      <ItpButton
        :text="'Create invoice...'|pgettext('RegisterEntry')"
        size="sm"
        variant="light"
        :tooltip="'Record a new invoice.'|pgettext('RegisterEntry')"
        :icon="$config.addIcon"
        v-if="editor.id"
        @click.prevent.stop="evh_5534025912102772_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
  </ItpBox>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegisterEntryInvoiceSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onOptionSelected(...args: any[]) {
    const [{ option, value }] = args;
    if (_.isObject(option)) {
      editor.invoice = _.cloneDeep(option);
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  editor!: object;

  @Watch('editor')
  onEditor(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("editor")
  }

  messages!: any;
  ux!: any;
  b_2248226175642056_dataSource!: any;

  async $$load_b_2248226175642056_dataSource() {
    return {
      name: "suggest_invoice",
      parameters: {
        company_id: this.editor.version.company_id,
        partner_id: this.editor.partner ? this.editor.partner.id : null,
      }
      ,
    }
  }

  dataMembers = ['messages', 'ux', 'b_2248226175642056_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          searchPlaceholder: this.$fn.pgettext("Register", "Search for invoice"),
        }
        ,
        ux: null,
        b_2248226175642056_dataSource: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_script_8056_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_8056, alias=undefined
    this.onOptionSelected($event)
  }

  async act_2248226175642056_script_8056_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_8056, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_8056_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_emit_8058_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5534025912102772_emit_8058, alias=undefined
    return {
      event: "close",
    }
  }

  async act_5534025912102772_showModal_8060_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5534025912102772_showModal_8060, alias=undefined
    return {
      name: "CreateInvoice",
      props: {
        registerEntry: this.editor.id,
      }
      ,
    }
  }

  async evh_5534025912102772_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8054: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8053: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_2248226175642056_script_8056: actions.ScriptAction;
    evh_2248226175642056_optionSelected_8055: actions.EventHandlerImpl;
    evh_2248226175642056_optionSelected: actions.EventHandlerGroup;
    act_5534025912102772_emit_8058: actions.EmitAction;
    evh_5534025912102772_clickPreventStop_8057: actions.EventHandlerImpl;
    act_5534025912102772_showModal_8060: actions.ShowModalAction;
    evh_5534025912102772_clickPreventStop_8059: actions.EventHandlerImpl;
    evh_5534025912102772_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8054 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8053 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8054,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8053],
      }
    );
    const act_2248226175642056_script_8056 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_8056_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_optionSelected_8055 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_8056,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_2248226175642056_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_optionSelected_8055],
      }
    );
    const act_5534025912102772_emit_8058 = new actions.EmitAction(
      {
        actionArgs: this.act_5534025912102772_emit_8058_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_clickPreventStop_8057 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_emit_8058,
        event: "click.prevent.stop",
        displayName: "emit",
      }
    );
    const act_5534025912102772_showModal_8060 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5534025912102772_showModal_8060_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_clickPreventStop_8059 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_showModal_8060,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_5534025912102772_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_clickPreventStop_8057, evh_5534025912102772_clickPreventStop_8059],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8054,
      evh_7315092382398562_reload_8053,
      evh_7315092382398562_reload,
      act_2248226175642056_script_8056,
      evh_2248226175642056_optionSelected_8055,
      evh_2248226175642056_optionSelected,
      act_5534025912102772_emit_8058,
      evh_5534025912102772_clickPreventStop_8057,
      act_5534025912102772_showModal_8060,
      evh_5534025912102772_clickPreventStop_8059,
      evh_5534025912102772_clickPreventStop,
    }
  }
}

Vue.component("UcRegisterEntryInvoiceSelector", UcRegisterEntryInvoiceSelector);

</script>